import { render, staticRenderFns } from "./team_registration_manager.vue?vue&type=template&id=19c1b85a&"
import script from "./team_registration_manager.vue?vue&type=script&lang=js&"
export * from "./team_registration_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports